import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Toggle from 'react-bootstrap-toggle';
import tinycolor from 'tinycolor2';
import { each, reduce, first, find, delay, indexOf, without, concat, uniq, filter } from 'lodash';
import pluralize from 'pluralize';

import { FormGroup, ControlLabel, Collapse, Button } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import styles from './styles.css';
import formStyles from '../../../../components/search-form/styles.css';
import { COLORS } from '../../../../components/search-form/master-field';


export function getAllPeriods() {
  return [
    { label: 'Weekly', value: 'week', labelAlt: 'weekly' },
    { label: 'Monthly', value: 'month', labelAlt: 'monthly' },
    { label: '60 Day', value: '60-day', labelAlt: '60 day' },
    { label: '90 Day', value: '90-day', labelAlt: '90 day' },
  ];
}

class ForecastAccuracyField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      period: props.forecastPeriod,
      categories: props.forecastCategories,
      openPeriod: false,
      openCategory: false,
    };
    this.setCategories = this.setCategories.bind(this);
    this.setPeriod = this.setPeriod.bind(this);
    this.submit = this.submit.bind(this);
    this.toggleOpenCategory = this.toggleOpenCategory.bind(this);
    this.toggleCloseCategory = this.toggleCloseCategory.bind(this);
  }

  setPeriod(period) {
    this.setState({ period, openPeriod: false });
    delay(() => {
      this.submit();
    }, 100);
  }

  setCategories(category) {
    const { categories } = this.state;
    let newCategories = [...categories];
    if (indexOf(newCategories, category) >= 0) {
      newCategories = without(newCategories, category);
    } else {
      newCategories = concat(newCategories, category);
    }
    const cats = uniq(newCategories);
    this.setState({ categories: cats });
  }

  getDefaultForecastCetegory(options) {
    return find(options, { label: 'Commit' }) || first(options);
  }
  getCategories(activeCategoryIds = []) {
    const { forecastCategoryFilter } = this.props;
    const options = reduce(forecastCategoryFilter ? forecastCategoryFilter.mappings : [], (items, mapping) => {
      items.push({
        ...mapping,
        active: indexOf(activeCategoryIds, mapping._id) >= 0,
      });
      return items;
    }, []);
    return options;
  }

  toggleOpenCategory() {
    const { openCategory } = this.state;
    this.setState({ openPeriod: false, openCategory: !openCategory });
  }
  
  toggleCloseCategory() {
    this.setState({ openPeriod: false, openCategory: false });
    const options = this.getCategories(this.state.categories);
    const commitOption = this.getDefaultForecastCetegory(options);
    if (this.state.categories.length === 0) {
      if (commitOption) {
        this.setCategories(commitOption._id);
      }
    }
    delay(() => {
      const remain1 = filter(this.state.categories, c => indexOf(this.state.forecastCategories, c) < 0);
      const remain2 = filter(this.state.forecastCategories, c => indexOf(this.state.categories, c) < 0);
      if (remain1.length > 0 || remain2.length > 0) {
        this.submit();
      }
    }, 100);
  }

  submit() {
    const { period, categories } = this.state;
    if (categories.length === 0) {
      const options = this.getCategories(categories);
      const commitOption = this.getDefaultForecastCetegory(options);
      if (commitOption) {
        categories.push(commitOption._id);
      }
    }
    this.props.onChange(period, categories);
  }

  renderPeriodList() {
    const { disabled } = this.props;
    const { period } = this.state;
    const allPeriods = getAllPeriods();
    const activePeriod = find(allPeriods, { value: period }) || first(allPeriods);
    return (
      <div className={`panel panel-default ${formStyles.dateRangePanel}`}>
        <div className="panel-body">
          <div className={styles.list}>
            {allPeriods.map((s) => {
              const active = activePeriod.value === s.value;
              return (
                <label
                  className="checkbox"
                  key={s.value}
                  onClick={() => {
                    if (!disabled) {
                      this.setPeriod(s.value);
                    }
                  }}
                >
                  <Fa name={active ? 'check-circle-o' : 'circle-o'} className={active ? 'text-active' : 'text-muted'} /> {s.label}
                </label>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
  renderCategoryList() {
    const { disabled } = this.props;
    const options = this.getCategories(this.state.categories);
    return (
      <div className={`panel panel-default ${formStyles.dateRangePanel}`}>
        <div className="panel-body">
          <div className={styles.list}>
            {options.map(s => (
              <label
                key={s._id}
                className="checkbox"
                onClick={() => {
                  if (!disabled) {
                    this.setCategories(s._id);
                  }
                }}
              >
                <Fa name={s.active ? 'check-square-o' : 'square-o'} className={s.active ? 'text-active' : 'text-muted'} /> {s.label}
              </label>
            ))}
          </div>
          <Button
            type="button"
            bsStyle="primary"
            bsSize="sm"
            disabled={disabled}
            onClick={this.toggleCloseCategory}
          >
            Apply
          </Button>
        </div>
      </div>
    );
  }


  render() {
    const {
      forecastClosedMonths,
    } = this.props;
    const { period } = this.state;

    const months = pluralize('month', forecastClosedMonths);

    const allPeriods = getAllPeriods();
    const activePeriod = find(allPeriods, { value: period }) || first(allPeriods);

    const options = this.getCategories(this.state.categories);
    // const categories = this.getCategories(forecastCategories);
    const defaultOption = this.getDefaultForecastCetegory(options);

    const activeLabels = [];
    each(options, (category) => {
      if (category.active) {
        activeLabels.push(category.label);
      }
    });
    let activeLabelString = defaultOption.label;
    if (activeLabels.length > 0) {
      activeLabelString = activeLabels.join(' + ');
    }

    const color = COLORS[1];
    const borderStyle = { borderColor: color, backgroundColor: tinycolor.mix(color, '#ffffff', 95).toHexString() };

    const toggleInner = (
      <span style={{ color }}>Including</span>
    );

    return (
      <div className={formStyles.field} style={borderStyle}>
        <FormGroup>
          <div className="row">
            <div className="col-sm-4 col-md-3">
              <div className="row">
                <div className="col-sm-6">
                  <ControlLabel>Forecast accuracy</ControlLabel>
                </div>
                <div className="col-sm-6">
                  <Button
                    disabled
                    bsSize="xs"
                    bsStyle="link"
                  >
                    {toggleInner}
                  </Button>
                </div>
              </div>
            </div>
            <div className="col-sm-8 col-md-9">
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.setState({ openPeriod: !this.state.openPeriod, openCategory: false });
                }}
                className={this.state.openPeriod ? styles.activeToggle : null}
              >
                {activePeriod.label} period
              </a>
              &nbsp;and&nbsp;
              <a
                href=""
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.toggleOpenCategory();
                }}
                className={this.state.openCategory ? styles.activeToggle : null}
              >
                {activeLabelString}
              </a>
              &nbsp;forecast accuracy for the past {forecastClosedMonths} {months}.
              <Collapse in={this.state.openPeriod}>
                <div>
                  {this.renderPeriodList()}
                </div>
              </Collapse>
              <Collapse in={this.state.openCategory}>
                <div>
                  {this.renderCategoryList()}
                </div>
              </Collapse>
            </div>
          </div>
        </FormGroup>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps() {
  return {};
}
ForecastAccuracyField.propTypes = {
  forecastCategoryFilter: PropTypes.shape({
    mappings: PropTypes.arrayOf(PropTypes.shape({
      _id: PropTypes.string.isRequired,
    })),
  }),
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  forecastCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  forecastPeriod: PropTypes.string.isRequired,
  forecastClosedMonths: PropTypes.number,
};
ForecastAccuracyField.defaultProps = {
  onChange: () => {},
  forecastCategoryFilter: null,
  forecastClosedMonths: 0,
  disabled: false,
};
export default connect(mapStateToProps)(ForecastAccuracyField);
